import scssVars from "~/assets/_vars-js.scss"
import { defineNuxtPlugin } from "#app"

export default defineNuxtPlugin((app) => {
  app.provide("scssVars", scssVars)
})
